import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, inject, Input, Output, signal } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { MaterialModule } from 'src/app/material.module';
import { IMiSimpleTableColumn, MiTableSimpleComponent } from 'src/app/shared/components/mi-table-simple/mi-table-simple.component';
import { StackDirectives } from 'src/app/shared/directives/stack-directives';
import { IListBox } from 'src/app/shared/interfaces/IClaveValor';
import { LoaderService } from 'src/app/shared/services/loader.service';
import { FilesUploaderComponent } from 'src/app/shared/components/files-uploader/files-uploader.component';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { Select } from 'primeng/select';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { DocumentViewerComponent } from 'src/app/apps/nodo/modules/terminos-negociacion/components/cliente-documentos-firmas/document-viewer/document-viewer.component';
import { ClientDocumentsService } from 'src/app/apps/nodo/modules/terminos-negociacion/services/client-documents.service';
import { MasterService } from 'src/app/shared/services/master.service';
import { catchError, of, throwError, finalize, exhaustMap, forkJoin, Observable, tap, map } from 'rxjs';
import { PersonService } from '../../services/person.service';
import { RequisicionesCandidatesDocumentsService } from 'src/app/shared/services/requisiciones-candidates-documents.service';
import { PersonDocumentsService } from '../../services/person-documents.service';
import { Checkbox } from 'primeng/checkbox';
import { Card, CardModule } from 'primeng/card';
import { ConfirmDeleteDialogComponent } from 'src/app/shared/components/confirm-delete/confirm-delete.component';

@Component({
    selector: 'app-info-documentos',
    imports: [StackDirectives, MaterialModule, CommonModule, TableModule, TagModule, Select, FormsModule, ButtonModule, TooltipModule],
    templateUrl: './info-documentos.html',
    styleUrl: './info-documentos.css',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class InfoDocumentos {
    private loader = inject(LoaderService);
    private toastr = inject(ToastrService);
    // private personAcademicService = inject(PersonAcademicService);
    private ac = inject(ActivatedRoute);
    private dialog = inject(MatDialog);
    private cdr = inject(ChangeDetectorRef);
    private clientDocumentsService = inject(ClientDocumentsService);
    private masterService = inject(MasterService);
    private personService = inject(PersonService);
    private personDocumentsService = inject(PersonDocumentsService);
    private router = inject(Router);

    idEncrypt: any;
    tiposDocumentos: any[] = [];
    tiposDocumentosSugeridos: any[] = [];
    files: any[] = [];
    filesToShow: any[] = [];
    urlFile: string | null = null;

    @Input() codEmp!: string;
    @Input() tipIde!: string;
    @Output() validChange = new EventEmitter<boolean>();

    readonly dataSource = signal<any[]>([]);
    readonly columns = signal<IMiSimpleTableColumn[]>([]);
    readonly displayedColumns = signal<string[]>([]);
    readonly filterColumns = signal<string[]>([]);

    ngOnInit() {
        this.ac.queryParams.subscribe((params) => {
            const rawId = params['q'];
            if (rawId) {
                this.idEncrypt = encodeURIComponent(rawId);
                this.loadData();
            } else {
                this.router.navigate(['/login']);
            }
        });
    }

    loadData() {
        forkJoin({
            documentsTypes: this.masterService
                .getDocumentTypeByCodCli(this.idEncrypt)
                .pipe(catchError((err) => (err.status === 204 ? of({ data: [] }) : throwError(() => err)))),
            documentsTypesSuggestion: this.masterService
                .getDocumentTypeSuggestionByCodCli(this.idEncrypt)
                .pipe(catchError((err) => (err.status === 204 ? of({ data: [] }) : throwError(() => err)))),
            documents: this.personDocumentsService
                .getDocumentsProcess(this.idEncrypt)
                .pipe(catchError((err) => (err.status === 204 ? of({ data: [] }) : throwError(() => err))))
        })
            .pipe(finalize(() => this.loader.hide()))
            .subscribe({
                next: ({ documentsTypes, documents, documentsTypesSuggestion }) => {
                    this.tiposDocumentos = documentsTypes.data;
                    if (documents) {
                        this.filesToShow = documents.data;
                        this.validChange.emit(true);
                    } else {
                        {
                            this.validChange.emit(false);
                        }
                    }
                    this.tiposDocumentosSugeridos = documentsTypesSuggestion.data;
                    this.cdr.markForCheck();
                },
                error: (e) => {
                    console.log('Error', e);
                }
            });
    }

    openModalCreate() {
        this.dialog
            .open(FilesUploaderComponent, {
                width: '600px',
                disableClose: true,
                data: {
                    title: 'Subir archivos',
                    description: 'Selecciona un archivo o varios para subir',
                    allowedExtensions: ['.pdf'],
                    maxFileSizeMb: 5
                }
            })
            .afterClosed()
            .subscribe((archivos) => {
                if (archivos) {
                    const start = this.files.length;
                    this.files = [...this.files, ...archivos];
                    archivos.forEach((file: any, i: number) => {
                        this.filesToShow.push({
                            name: file.name,
                            size: file.size,
                            id: '',
                            tipo: '',
                            index: start + i,
                            useSign: false,
                            indSignProcess: false,
                            dateDownloadSign: null
                        });
                    });
                    this.cdr.markForCheck();
                    this.cdr.detectChanges();
                } else {
                    console.log('No se subió ningún archivo');
                }
            });
    }

    searchTypeDocument(id: string) {
        const tipo = this.tiposDocumentos.find((tipo) => tipo.id === id);
        if (tipo !== undefined) {
            return tipo.label ?? '';
        }
        return '';
    }

    removeFile(index: number) {
        const fileToRemove = this.filesToShow[index];
        const indexFile = this.files.findIndex((f) => f.name === fileToRemove.name);
        console.log(indexFile);
        if (indexFile !== -1) {
            this.files.splice(indexFile, 1);
        }
        this.filesToShow.splice(index, 1);
        this.cdr.markForCheck();
    }

    getDocument(fileId: string, name: string): void {
        this.loader.show('Cargando archivo...');
        of(fileId)
            .pipe(
                exhaustMap((fileId) =>
                    this.personDocumentsService.getDocumentById(this.idEncrypt, fileId).pipe(
                        catchError((error) => {
                            this.toastr.error(error.error.mensaje, 'Error');
                            return of(null);
                        }),
                        finalize(() => this.loader.hide())
                    )
                )
            )
            .subscribe((response) => {
                if (response) {
                    this.urlFile = response.data.url;
                    this.dialog
                        .open(DocumentViewerComponent, {
                            width: '800px',
                            maxWidth: '90vw',
                            data: {
                                urlPdf: this.urlFile,
                                title: name,
                                indProcessSign: response.data.indSignProcess,
                                dateDownloadSign: response.data.dateDownloadSign
                            }
                        })
                        .afterClosed();
                    this.cdr.markForCheck();
                }
            });
    }

    deleteFile(index: number, fileId: string): void {
        this.dialog
            .open(ConfirmDeleteDialogComponent, {
                width: '400px',
                data: {
                    title: `Confirmar eliminación ${this.filesToShow[index].name}`,
                    message: '¿Está seguro de que desea eliminar este archivo?'
                }
            })
            .afterClosed()
            .subscribe((confirmed) => {
                if (confirmed) {
                    this.loader.show('Eliminando archivo...');
                    of(fileId)
                        .pipe(
                            exhaustMap((fileId) =>
                                this.personDocumentsService.deleteDocument(this.idEncrypt, fileId).pipe(
                                    catchError((error) => {
                                        this.toastr.error(error.error.mensaje, 'Error');
                                        return of(null);
                                    }),
                                    finalize(() => this.loader.hide())
                                )
                            )
                        )
                        .subscribe((response) => {
                            console.log(response);
                            if (response) {
                                this.toastr.success('Archivo eliminado correctamente', 'Éxito');
                                this.removeFile(index);
                                this.loadData();
                                this.cdr.markForCheck();
                            }
                        });
                }
            });
    }

    uploadFile$(): Observable<boolean> {
        if (this.files.length === 0) {
            this.toastr.info('No hay archivos para subir', 'Atención');
            return of(true);
        }

        if (!this.validateFiles()) {
            return of(false);
        }

        const formData = new FormData();
        this.files.forEach((file) => formData.append('files', file));

        const filesNotUpload = this.filesToShow.filter((file) => file.id === '');
        // Reindexar 0..n-1 en el mismo orden que this.files: el backend casa files[i] con info por el campo index
        filesNotUpload.forEach((file, i) => (file.index = i));
        formData.append('info', JSON.stringify(filesNotUpload));

        this.loader.show('Subiendo archivos...');
        return of(formData).pipe(
            exhaustMap((fd) =>
                this.personDocumentsService.uploadFile(this.idEncrypt, fd).pipe(
                    tap((response) => {
                        if (response) {
                            this.toastr.success('Archivos subidos correctamente', 'Éxito');

                            this.files = [];
                            this.filesToShow = this.filesToShow.filter((file) => file.id !== '');
                            this.filesToShow.push(...response.data);

                            this.loadData();

                            this.cdr.markForCheck();
                        }
                    }),
                    map((response) => !!response), // true si response existe, false si vino null
                    catchError((error) => {
                        this.toastr.error(error?.error?.mensaje ?? 'Error al subir archivos', 'Error');
                        return of(false);
                    }),
                    finalize(() => this.loader.hide())
                )
            )
        );
    }

    validateFiles() {
        for (const file of this.filesToShow) {
            if (file.tipo.trim() === '') {
                this.toastr.error('Por favor, complete todos los campos obligatorios');
                return false;
            }
        }
        return true;
    }
}
